import React, { useEffect, useRef, useState } from 'react';

// Count-up animation that starts when element enters viewport
export const AnimatedStat = ({ value, suffix = '', label, duration = 1400 }) => {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  const target = Number(value) || 0;

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (t) => {
            const p = Math.min(1, (t - start) / duration);
            setN(Math.floor(target * (0.5 - Math.cos(Math.PI * p) / 2)));
            if (p < 1) requestAnimationFrame(tick);
            else setN(target);
          };
          requestAnimationFrame(tick);
        }
      });
    }, { threshold: 0.4 });
    io.observe(el);
    return () => io.disconnect();
  }, [target, duration]);

  return (
    <div ref={ref} className="text-center group">
      <div className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#0A2463] to-[#247BA0] group-hover:scale-105 transition-transform inline-flex items-baseline">
        {n.toLocaleString('en-IN')}<span className="text-[#FB8500]">{suffix}</span>
      </div>
      <div className="text-sm md:text-base text-gray-600 font-semibold mt-1">{label}</div>
    </div>
  );
};

export default AnimatedStat;
